









import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Loading extends Vue {
    @Prop() public active: boolean;
    @Prop({ type: Boolean, default: true }) public isFullPage: boolean;
    @Prop({ type: String, default: 'fade' }) public animation: boolean;
    @Prop({ type: Boolean, default: false }) public canCancel: boolean;
    @Prop({ type: Function, default: () => {} }) public onCancel: () => {};

    public isActive: boolean = this.active || false;

    @Watch('active')
    public activeChanged(value: boolean) {
        this.isActive = value;
    }
    public cancel(): void {
        if (!this.canCancel || !this.isActive) {
            return;
        }

        this.close();
    }
    public close(): void {
        this.onCancel.apply(null, []);
        this.$emit('close');
        this.$emit('update:active', false);
    }
    public keyPress(event: KeyboardEvent) {
        if (event.keyCode === 27) {
            this.cancel();
        }
    }

    public created(): void {
        if (typeof window !== 'undefined') {
            document.addEventListener('keyup', this.keyPress);
        }
    }
    public beforeDestroy(): void {
        if (typeof window !== 'undefined') {
            document.removeEventListener('keyup', this.keyPress);
        }
    }
}
